import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { ReactNode, StrictMode } from 'react';
import { DynamicThemeProvider } from './context/DynamicThemeProvider';

type Props = {
  children: ReactNode;
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10000,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: 3
    }
  }
});

export default function AllProviders({ children }: Props) {
  return (
    <StrictMode>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <DynamicThemeProvider>{children}</DynamicThemeProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </StrictMode>
  );
}
